export default "__VITE_ASSET__Bfl77Ab3__"